<mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
</mat-card-header>
<mat-card-content class="mat-card-style-kc-search-result">
    <div class="table-responsive" style="width:75%;margin-top:10px;margin-left:20px">
        <table mat-table multiTemplateDataRows [dataSource]="dataSource" matSort #sort="matSort">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="border-bottom-double" style="width: 5px;"></th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    <mat-radio-button [value]="row" (change)="onChangeRadio($event, row)"
                        (click)="$event.stopPropagation()" class="text-center" [disabled]="isRadioButtonDisabled">
                    </mat-radio-button>
                </td>
            </ng-container>
            <ng-container matColumnDef="tankatableAname">
                <th mat-header-cell class="border-bottom-double" style="width: 250px;" *matHeaderCellDef
                    mat-sort-header>単価表名</th>
                <td mat-cell *matCellDef="let row">{{ row.tankatableAname }}</td>
            </ng-container>
            <ng-container matColumnDef="applyStartDate">
                <th mat-header-cell class="border-bottom-double" style="width: 50px;" *matHeaderCellDef mat-sort-header>
                    適用開始年月</th>
                <td mat-cell *matCellDef="let row">{{row.applyStartDate | dateYmStringSg}}</td>
            </ng-container>
            <ng-container matColumnDef="applyEndDate">
                <th mat-header-cell class="border-bottom-double" style="width: 50px;" *matHeaderCellDef mat-sort-header>
                    適用終了年月</th>
                <td mat-cell *matCellDef="let row">{{ row.applyEndDate | dateYmStringSg}}</td>
            </ng-container>
            <ng-container matColumnDef="tankatableExplanation">
                <th mat-header-cell class="border-bottom-double" style="width: 200px;" *matHeaderCellDef
                    mat-sort-header>単価表説明</th>
                <td mat-cell *matCellDef="let row">{{row.tankatableExplanation}}</td>
            </ng-container>
            <ng-container matColumnDef="apprvStsAname">
                <th mat-header-cell class="border-bottom-double" style="width: 50px;" *matHeaderCellDef mat-sort-header>
                    ステータス</th>
                <td mat-cell *matCellDef="let row">{{row.apprvStsAname}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
            <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol"
                (dblclick)="$event ? onDbClickRow(row, $event): null"></tr>
        </table>
        <mat-paginator #paginator [pageSize]="50" showFirstLastButtons id="paginator">
        </mat-paginator>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
        <mat-card-actions class="btn_area_right">
            <button *ngIf="isAddButtonVisible" [disabled]="isAddButtonDisabled" type="button" mat-raised-button
                color="primary" (click)="onClickAdd()" id="add">追加</button>
        </mat-card-actions>
    </div>
</mat-card-content>